import { SlackChannels } from '../../../pure-js/types/SlackChannels.js'
import { User as SentryUser } from '../Sentry.js'
import { slack } from '../SlackHelper.js'

export const error = (error: Error, user?: SentryUser) =>
  slack(
    `user: ${user?.email || ''}\n${error.name} ${error.message} ${error.stack}`,
    SlackChannels.OPS_INTRACTION_ERRORS
  )
